module.exports = __webpack_public_path__ + "img/list-third.1eb682b0.svg";